<template>
  <v-app style="max-width: 1440px; margin: auto;">
    <v-content>
        <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {},

  data: () => ({
    //
  }),

  methods: {
    openDemo() {
      this.$refs.demoBlock.buttonClicked();
    }
  }

};
</script>